import React from 'react';
import PropTypes from 'prop-types';
import { Drawer } from '@unite-us/app-components';
import TaskView from './TaskView';

const TaskDetailsDrawer = ({
  taskId,
  isOpen,
  onClose,
  onOpenFullView,
}) => (
  <Drawer
    open={isOpen}
    onClose={onClose}
    secondary
    width="500px"
    topOffset="60px"
    className="border border-solid border-medium-border-blue"
    id="tasks-v3-task-details-drawer"
  >
    {isOpen && taskId && (
      <TaskView
        key={taskId}
        taskId={taskId}
        isTaskDrawer
        hideNavigation
        onOpenFullView={onOpenFullView}
      />
    )}
  </Drawer>
);

TaskDetailsDrawer.propTypes = {
  taskId: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onOpenFullView: PropTypes.func,
};

TaskDetailsDrawer.defaultProps = {
  taskId: null,
  onOpenFullView: null,
};

export default TaskDetailsDrawer;
